const LOADING_LABEL = 'Loading';

export default LOADING_LABEL;
